// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* ========================================= */
 /*              GLOBAL STYLES                */
 /* ========================================= */
 .api-document-wrapper {
     font-family: 'Inter', sans-serif;
     color: #1a1a1a;
     background: #ffffff;
     line-height: 1.5;
 }

 /* ========================================= */
 /*               HERO SECTION                */
 /* ========================================= */
 .api-hero-section {
     background-size: cover;
     background-position: center;
     padding: 40px 0px;
     display: flex;
     align-items: center;
     justify-content: center;
     min-height: 550px;
 }

 .api-hero-container {
     display: flex;
     align-items: center;
     justify-content: space-between;
     max-width: 1480px;
     padding: 0px 20px;
     width: 100%;
     margin: 0 auto;
 }

 .api-hero-content {
     max-width: 550px;
 }

 .api-badge {
     color: #D1AA67;
     font-weight: 500;
     font-size: 14px;
     background-color: #FDF6E9;
     margin-bottom: 15px;
     display: inline-block;
     border-radius: 15px;
     font-weight: 600;
     padding: 4px 10px;
 }

 .api-hero-content h1 {
     font-size: 72px;
     font-weight: 700;
     margin-bottom: 20px;
     color: #1a1a1a;
     line-height: 1.1;
 }

 .api-hero-content h1 span {
     color: #D1AA67;
 }

 .api-hero-content p {
     font-size: 18px;
     color: #4B5563;
     line-height: 1.6;
     margin-bottom: 30px;
     max-width: 90%;
 }

 .api-btn-group {
     display: flex;
     gap: 15px;
     margin-bottom: 45px;
 }

 .api-btn-group a {
     padding: 15px 30px;
     border-radius: 30px;
     text-align: center;
     font-weight: 700;
     font-size: 14px;
     transition: 0.3s;
     text-decoration: none;
 }


 .btn-black {
     background-color: #1a1a1a;
     color: #fff;
 }

 .btn-black:hover {
     background-color: #333;
     color: #fff;
 }

 .btn-grey {
     background-color: #ECECEC;
     color: #1a1a1a;
     text-decoration: none;
 }

 .btn-grey:hover {
     background-color: #e4e4e4;
 }

 .api-features-list {
     display: flex;
     gap: 25px;
     font-size: 12px;
     color: #374151;
     font-weight: 700;
 }

 .api-features-list span {
     display: flex;
     align-items: center;
     gap: 6px;
     text-decoration: underline;
 }

 .api-features-list svg {
     color: #d2a154;
 }

 .api-hero-image img {
     max-width: 590px;
     width: 100%;
 }

 /* ========================================= */
 /*   ALL-IN-ONE TRADING DATA & ACCOUNT SRV   */
 /* ========================================= */
 .api-services-section {
     padding: 80px 0px;
     text-align: center;
     background: #ffffff;
 }

 .api-services-container {
     max-width: 1480px;
     padding: 0px 20px;
     margin: 0 auto;
 }

 .api-section-title {
     font-size: 40px;
     letter-spacing: 0.5px;
     font-weight: 700;
     margin-bottom: 12px;
     color: #1a1a1a;
 }

 .api-section-subtitle {
     font-size: 20px;
     color: #6B7280;
     margin-bottom: 50px;
 }

 /* DIAGRAM */
 .api-diagram {
     position: relative;
     max-width: 100%;
     margin: 0 auto 30px auto;
     padding-top: 40px;

 }

 .diagram-top-line {
     position: absolute;
     max-width: 85%;
     margin: 0 auto;
     top: 0;
     left: 50px;
     right: 50px;
     border-top: 2px dashed #b3b3b3;
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 1;
 }

 .diagram-top-line .diagram-arrow-left {
     position: absolute;
     left: -10px;
     top: -13px;
     color: #b3b3b3;
     font-size: 16px;
 }

 .diagram-top-line .diagram-arrow-right {
     position: absolute;
     right: -10px;
     top: -13px;
     color: #b3b3b3;
     font-size: 16px;
 }

 .diagram-pill {
     background: #ffffff;
     border: 1px solid #eaeaea;
     border-radius: 40px;
     padding: 8px 18px;
     font-size: 16px;
     font-weight: 600;
     color: #1a1a1a;
     position: relative;
     top: -21px;
     z-index: 5;
 }

 .diagram-main-row {
     display: flex;
     justify-content: space-between;
     align-items: center;
     position: relative;
 }

 .diagram-item {
     display: flex;
     flex-direction: column;
     align-items: center;
     z-index: 10;
     width: 120px;
 }

 .diagram-icon {
     background: #f8efe1;
     border-radius: 50%;
     display: flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 15px;
 }

 .diagram-icon.large {
     width: 100px;
     height: 100px;
 }

 .diagram-icon.large img {
     width: 50px;
 }

 .diagram-icon.small {
     width: 80px;
     height: 80px;
     opacity: 1;
 }

 .diagram-icon.small img {
     width: 35px;
 }

 .diagram-title {
     font-weight: 600;
     font-size: 24px;
     color: #1a1a1a;
 }

 .diagram-line-container {
     flex: 1 1;
     display: flex;
     align-items: center;
     position: relative;
     margin: 0 10px;
     top: -15px;
     /* align with the middle of circles (considering text is below) */
 }

 .diagram-line-dashed.gold {
     width: 100%;
     border-top: 2px dashed #d2af75;
     display: flex;
     justify-content: center;
     align-items: center;
     position: relative;
 }

 .diagram-line-dashed.gold .diagram-arrow-left {
     position: absolute;
     left: -8px;
     top: -16px;
     color: #d2af75;
     font-size: 20px;
 }

 .diagram-line-dashed.gold .diagram-arrow-right {
     position: absolute;
     right: -8px;
     top: -16px;
     color: #d2af75;
     font-size: 20px;
 }

 /* ========================================= */
 /*               SECTION DIVIDER             */
 /* ========================================= */


 .api-divider {
     display: flex;
     align-items: center;
     justify-content: center;
     margin: 80px 0 0px 0;
 }

 .market_data_section .api-cards-grid {
     margin-top: 45px;
 }

 .api-divider span {
     font-size: 40px;
     font-weight: 600;
     letter-spacing: 0.5px;
     margin: 0 20px;
     color: #1a1a1a;
 }

 .market_data_section p {
     font-size: 19px;
     color: #6B7280;
 }

 .api-divider::before,
 .api-divider::after {
     content: '';
     height: 4px;
     width: 40px;
     background: #d2a154;
 }

 /* ========================================= */
 /*               CARDS LAYOUT                */
 /* ========================================= */
 .api-cards-grid {
     display: grid;
     grid-template-columns: 1fr 1fr;
     gap: 24px;
     max-width: 100%;
     margin: 0 auto;
     text-align: left;
 }

 .api-card {
     background: #ffffff;
     border-radius: 12px;
     padding: 36px;
     box-shadow: 0 0px 15px rgb(0 0 0 / 22%);
     border: 1px solid #34353920;
     border-left: 2.8px solid #343539;
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     transition: transform 0.2s, box-shadow 0.2s;
 }

 .api-card:hover {
     transform: translateY(-2px);
     box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
 }

 .api-card h3 {
     font-size: 28px;
     font-weight: 700;
     margin-bottom: 26px;
     color: #1A1A1A;
 }

 .api-card p {
     font-size: 17px;
     color: #666;
     margin-bottom: 24px;
     line-height: 1.6;
 }

 .market_data_section .api-card h3 {
     font-size: 24px;
     margin-bottom: 6px;
 }

 .api-tags {
     width: 70%;
     display: grid;
     grid-template-columns: repeat(2, 1fr);
     gap: 15px;
     column-gap: 32px;
     margin-bottom: auto;
     padding-bottom: 30px;
 }

 .api-tag {
     background: #EBEBEB;
     display: flex;
     justify-content: center;
     align-items: center;
     padding: 11px 22px;
     text-align: center;
     border-radius: 40px;
     font-size: 16px;
     color: #333;
     font-weight: 600;
     border: 1px solid #F3F4F6;
 }

 .api-card-bottom {
     margin-top: 10px;
 }

 .api-hot-module {
     font-size: 15px;
     color: #D1AA67;
     font-weight: 600;
     margin-bottom: 10px;
 }

 .api-card-action {
     background: #EBEBEB;
     padding: 16px 20px;
     border-radius: 50px;
     display: flex;
     justify-content: space-between;
     align-items: center;
     text-decoration: none;
     color: #1a1a1a;
     font-size: 16px;
     font-weight: 500;
     transition: 0.2s;
 }

 .api-card-action:hover {
     background: #d1aa67;
     color: #ffff;
 }

 .api-card-action:hover svg {
     color: #ffff;
 }

 .api-github-btn {
     background: #d2a154;
     color: #fff;
     display: inline-flex;
     align-items: center;
     gap: 8px;
     padding: 10px 20px;
     border-radius: 25px;
     text-decoration: none;
     font-weight: 600;
     font-size: 14px;
     transition: 0.3s;
 }

 .api-github-btn:hover {
     background: #c29144;
     color: #fff;
 }

 /* ========================================= */
 /*               BENEFITS SECTION            */
 /* ========================================= */
 .api-benefits-section {
     background-size: cover;
     background-position: center;
     padding: 80px 0px;
     text-align: center;
 }

 .api-benefits-container {
     max-width: 1480px;
     padding: 0px 20px;
     margin: 0 auto;
 }

 .api-benefits-grid {
     display: grid;
     grid-template-columns: 1fr 1fr;
     gap: 32px;
     margin-top: 40px;
 }

 .api-benefit-card {
     background: #ffffff;
     padding: 36px;
     border-radius: 12px;
     text-align: left;
     border: 1px solid #EFEFEF;
     box-shadow: 0 4px 20px rgb(0 0 0 / 9%);
 }

 .api-benefit-card h4 {
     font-size: 24px;
     font-weight: 700;
     margin-bottom: 5px;
     color: #1a1a1a;
 }

 .api-benefit-card p {
     font-size: 17px;
     color: #6B7280;
     line-height: 1.6;
 }

 /* ========================================= */
 /*                  FAQ SECTION              */
 /* ========================================= */
 .api-faq-section {
     padding: 60px 0px;
     background: #ffffff;
 }

 .api-faq-container {
     max-width: 1480px;
     padding: 0px 20px;
     margin: 0 auto;
 }

 .api-faq-container h2 {
     font-size: 40px;
     font-weight: 700;
     margin-bottom: 30px;
     text-align: left;
     color: #1a1a1a;
 }

 .api-faq-item {
     background: #F5F5F5;
     border-radius: 10px;
     padding: 20px 24px;
     margin-bottom: 12px;
     display: flex;
     justify-content: space-between;
     border: 1px solid #F3F4F6;
     align-items: center;
     cursor: pointer;
     font-weight: 600;
     font-size: 16px;
     transition: background 0.3s;
     color: #1a1a1a;
 }

 .api-faq-item:hover {
     background: #f0f0f0;
 }

 .api-faq-answer {
     padding: 0 24px 24px 24px;
     font-size: 15px;
     color: #666;
     line-height: 1.6;
     background: #f7f7f7;
     border-radius: 0 0 8px 8px;
     margin-top: -12px;
     margin-bottom: 12px;
 }

 .api-faq-icon {
     color: #999;
     transition: transform 0.3s;
 }

 .api-faq-icon.open {
     transform: rotate(180deg);
 }

 /* ========================================= */
 /*               RESPONSIVE                  */
 /* ========================================= */


 @media (max-width:1500px) {

     .api-hero-container {
         max-width: 95%;
     }

     .api-services-container {
         max-width: 95%;
     }

     .api-benefits-container {
         max-width: 95%;
     }

     .api-faq-container {
         max-width: 95%;
     }

     .api-hero-content h1 {
         font-size: 54px;
     }


 }


 @media (max-width:1200px) {

     .api-hero-content h1 {
         font-size: 48px;
     }

     .api-hero-content p {
         font-size: 16px;
     }

     .api-section-title {
         font-size: 32px;
     }

     .api-card h3 {
         font-size: 24px;
     }

     .diagram-title {
         font-size: 20px;
     }

     .diagram-pill {
         padding: 5px 14px;
         font-size: 13px;
     }

     .api-tag {
         padding: 9px 18px;
         font-size: 13px;
     }

     .api-tags {
         width: 90%;
         column-gap: 18px;
         padding-bottom: 18px;
     }

     .api-card-action {
         padding: 13px 18px;
         font-size: 14px;
     }

     .api-divider span {
         font-size: 32px;
     }

     .market_data_section p {
         font-size: 16px;
     }

     .market_data_section .api-card h3 {
         font-size: 20px;
     }

     .api-benefit-card h4 {
         font-size: 20px;
     }

     .api-benefit-card p {
         font-size: 15px;
     }

     .api-faq-container h2 {
         font-size: 32px;
     }


 }

 @media (max-width: 992px) {

     .api-hero-content {
         margin-bottom: 10px;
         max-width: 100%;
     }

     .api-hero-content p {
         margin: 0 auto 24px auto;
         max-width: 100%;
     }

     .api-btn-group a {
         padding: 11px 24px;
         font-size: 13px;
     }

     .api-hero-image img {
         max-width: 470px;
     }

     .api-hero-content h1 {
         font-size: 36px;
     }

     .api-hero-section {
         min-height: 480px;
     }

     .api-services-section {
         padding: 40px 0px;
     }

     .api-section-title {
         font-size: 26px;
     }

     .api-section-subtitle {
         font-size: 16px;
         margin-bottom: 40px;
     }

     .diagram-icon.large {
         width: 50px;
         height: 50px;
     }

     .diagram-icon.large img {
         width: 24px;
     }

     .diagram-icon.small {
         width: 50px;
         height: 50px;
     }

     .api-features-list {
         justify-content: center;
     }

     .api-diagram {
         flex-direction: column;
         gap: 20px;
     }

     .diagram-line-container {
         width: 100%;
         height: 60px;
         margin: 15px 0;
         top: 0;
     }

     .diagram-line-dashed {
         width: 1px;
         height: 100%;
         border-top: none;
     }

     .diagram-arrow-left {
         top: -2px;
     }

     .diagram-line-dashed.gold {
         border-top: none;
     }

     .diagram-main-row .diagram-arrow-right {
         display: none;
     }

     .diagram-title {
         font-size: 16px;
     }

     .api-faq-container h2 {
         font-size: 26px;
     }

     .diagram-line-dashed.gold .diagram-arrow-left {
         display: none;
     }

     .diagram-label-top,
     .diagram-label-bottom {
         position: absolute;
         left: 20px;
         margin: 0;
     }

     .diagram-label-top {
         top: 10px;
     }

     .diagram-label-bottom {
         bottom: 10px;
     }
 }

 @media (max-width: 768px) {

     .api-cards-grid,
     .api-benefits-grid {
         grid-template-columns: 1fr;
     }

     .api-hero-content h1 {
         font-size: 42px;
     }

     .api-divider span {
         font-size: 22px;
     }
 }

 @media (max-width: 767px) {


     .api-benefits-section {
         padding: 30px 0px;
     }

     .api-benefit-card {
         padding: 22px;
     }

     .api-benefits-grid {
         margin-top: 20px;
         gap: 24px;
     }

     .api-faq-section {
         padding: 24px 0px;
     }

     .api-faq-container h2 {
         font-size: 22px;
         margin-bottom: 15px;
     }

     .api-faq-item {
         padding: 15px;
         font-size: 15px;
     }

     .api-hero-content h1 {
         font-size: 32px;
     }

     .api-hero-container {
         text-align: center;
         flex-direction: column;
         gap: 24px;
     }

     .api-hero-section {
         min-height: 100%;
         padding: 50px 0px;
     }

     .api-btn-group a {
         padding: 10px 15px;
         font-size: 12px;
     }

     .api-card {
         padding: 24px;
     }

     .api-card h3 {
         font-size: 20px;
         margin-bottom: 20px;
     }

     .api-tags {
         width: 100%;
         column-gap: 12px;
         padding-bottom: 15px;
     }

     .api-services-section {
         padding: 10px 0px 40px;
     }

     .api-section-title {
         font-size: 22px;
     }

     .api-section-subtitle {
         font-size: 15px;
         margin-bottom: 30px;
     }


     .diagram-main-row {
         flex-wrap: wrap;
         gap: 18px;
     }

     .diagram-top-line {
         max-width: 100%;
         left: 0px;
         right: 0px;
     }

     .api-hero-image img {
         max-width: 340px;
     }

     .api-btn-group {
         justify-content: center;
         margin-bottom: 28px;
     }

     .api-hero-content p {
         font-size: 15px;
         margin: 0 auto 18px auto;
     }

     .api-divider {
         margin: 40px 0 0px 0;
     }

     .market_data_section .api-cards-grid {
         margin-top: 24px;
     }

     .market_data_section p {
         font-size: 15px;
     }

 }


 @media (max-width:580px) {

     .api-tag {
         padding: 8px 15px;
         font-size: 12px;
     }

     .api-card-action {
         padding: 12px 18px;
         font-size: 13px;
     }


 }`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ApiDocument/apidocument.css"],"names":[],"mappings":"CAAC,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,gCAAgC;KAChC,cAAc;KACd,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,sBAAsB;KACtB,2BAA2B;KAC3B,iBAAiB;KACjB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,iBAAiB;CACrB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,iBAAiB;KACjB,iBAAiB;KACjB,WAAW;KACX,cAAc;CAClB;;CAEA;KACI,gBAAgB;CACpB;;CAEA;KACI,cAAc;KACd,gBAAgB;KAChB,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,qBAAqB;KACrB,mBAAmB;KACnB,gBAAgB;KAChB,iBAAiB;CACrB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,cAAc;KACd,gBAAgB;CACpB;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,mBAAmB;KACnB,cAAc;CAClB;;CAEA;KACI,aAAa;KACb,SAAS;KACT,mBAAmB;CACvB;;CAEA;KACI,kBAAkB;KAClB,mBAAmB;KACnB,kBAAkB;KAClB,gBAAgB;KAChB,eAAe;KACf,gBAAgB;KAChB,qBAAqB;CACzB;;;CAGA;KACI,yBAAyB;KACzB,WAAW;CACf;;CAEA;KACI,sBAAsB;KACtB,WAAW;CACf;;CAEA;KACI,yBAAyB;KACzB,cAAc;KACd,qBAAqB;CACzB;;CAEA;KACI,yBAAyB;CAC7B;;CAEA;KACI,aAAa;KACb,SAAS;KACT,eAAe;KACf,cAAc;KACd,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,0BAA0B;CAC9B;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,gBAAgB;KAChB,WAAW;CACf;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,iBAAiB;KACjB,kBAAkB;KAClB,mBAAmB;CACvB;;CAEA;KACI,iBAAiB;KACjB,iBAAiB;KACjB,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,qBAAqB;KACrB,gBAAgB;KAChB,mBAAmB;KACnB,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,mBAAmB;CACvB;;CAEA,YAAY;CACZ;KACI,kBAAkB;KAClB,eAAe;KACf,wBAAwB;KACxB,iBAAiB;;CAErB;;CAEA;KACI,kBAAkB;KAClB,cAAc;KACd,cAAc;KACd,MAAM;KACN,UAAU;KACV,WAAW;KACX,8BAA8B;KAC9B,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,UAAU;CACd;;CAEA;KACI,kBAAkB;KAClB,WAAW;KACX,UAAU;KACV,cAAc;KACd,eAAe;CACnB;;CAEA;KACI,kBAAkB;KAClB,YAAY;KACZ,UAAU;KACV,cAAc;KACd,eAAe;CACnB;;CAEA;KACI,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,iBAAiB;KACjB,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,kBAAkB;KAClB,UAAU;KACV,UAAU;CACd;;CAEA;KACI,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,WAAW;KACX,YAAY;CAChB;;CAEA;KACI,mBAAmB;KACnB,kBAAkB;KAClB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;KACI,YAAY;KACZ,aAAa;CACjB;;CAEA;KACI,WAAW;CACf;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,UAAU;CACd;;CAEA;KACI,WAAW;CACf;;CAEA;KACI,gBAAgB;KAChB,eAAe;KACf,cAAc;CAClB;;CAEA;KACI,SAAO;KACP,aAAa;KACb,mBAAmB;KACnB,kBAAkB;KAClB,cAAc;KACd,UAAU;KACV,iEAAiE;CACrE;;CAEA;KACI,WAAW;KACX,8BAA8B;KAC9B,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,kBAAkB;KAClB,UAAU;KACV,UAAU;KACV,cAAc;KACd,eAAe;CACnB;;CAEA;KACI,kBAAkB;KAClB,WAAW;KACX,UAAU;KACV,cAAc;KACd,eAAe;CACnB;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;;;CAG9C;KACI,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,oBAAoB;CACxB;;CAEA;KACI,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,cAAc;KACd,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;CAClB;;CAEA;;KAEI,WAAW;KACX,WAAW;KACX,WAAW;KACX,mBAAmB;CACvB;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,aAAa;KACb,8BAA8B;KAC9B,SAAS;KACT,eAAe;KACf,cAAc;KACd,gBAAgB;CACpB;;CAEA;KACI,mBAAmB;KACnB,mBAAmB;KACnB,aAAa;KACb,uCAAuC;KACvC,2BAA2B;KAC3B,gCAAgC;KAChC,aAAa;KACb,sBAAsB;KACtB,2BAA2B;KAC3B,2CAA2C;CAC/C;;CAEA;KACI,2BAA2B;KAC3B,0CAA0C;CAC9C;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,WAAW;KACX,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,kBAAkB;CACtB;;CAEA;KACI,UAAU;KACV,aAAa;KACb,qCAAqC;KACrC,SAAS;KACT,gBAAgB;KAChB,mBAAmB;KACnB,oBAAoB;CACxB;;CAEA;KACI,mBAAmB;KACnB,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;KACnB,eAAe;KACf,WAAW;KACX,gBAAgB;KAChB,yBAAyB;CAC7B;;CAEA;KACI,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;KACnB,qBAAqB;KACrB,cAAc;KACd,eAAe;KACf,gBAAgB;KAChB,gBAAgB;CACpB;;CAEA;KACI,mBAAmB;KACnB,YAAY;CAChB;;CAEA;KACI,YAAY;CAChB;;CAEA;KACI,mBAAmB;KACnB,WAAW;KACX,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;KACR,kBAAkB;KAClB,mBAAmB;KACnB,qBAAqB;KACrB,gBAAgB;KAChB,eAAe;KACf,gBAAgB;CACpB;;CAEA;KACI,mBAAmB;KACnB,WAAW;CACf;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,sBAAsB;KACtB,2BAA2B;KAC3B,iBAAiB;KACjB,kBAAkB;CACtB;;CAEA;KACI,iBAAiB;KACjB,iBAAiB;KACjB,cAAc;CAClB;;CAEA;KACI,aAAa;KACb,8BAA8B;KAC9B,SAAS;KACT,gBAAgB;CACpB;;CAEA;KACI,mBAAmB;KACnB,aAAa;KACb,mBAAmB;KACnB,gBAAgB;KAChB,yBAAyB;KACzB,sCAAsC;CAC1C;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,kBAAkB;KAClB,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;CACpB;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C;KACI,iBAAiB;KACjB,mBAAmB;CACvB;;CAEA;KACI,iBAAiB;KACjB,iBAAiB;KACjB,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,gBAAgB;KAChB,cAAc;CAClB;;CAEA;KACI,mBAAmB;KACnB,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,aAAa;KACb,8BAA8B;KAC9B,yBAAyB;KACzB,mBAAmB;KACnB,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,2BAA2B;KAC3B,cAAc;CAClB;;CAEA;KACI,mBAAmB;CACvB;;CAEA;KACI,yBAAyB;KACzB,eAAe;KACf,WAAW;KACX,gBAAgB;KAChB,mBAAmB;KACnB,0BAA0B;KAC1B,iBAAiB;KACjB,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,0BAA0B;CAC9B;;CAEA;KACI,yBAAyB;CAC7B;;CAEA,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;;;CAG9C;;KAEI;SACI,cAAc;KAClB;;KAEA;SACI,cAAc;KAClB;;KAEA;SACI,cAAc;KAClB;;KAEA;SACI,cAAc;KAClB;;KAEA;SACI,eAAe;KACnB;;;CAGJ;;;CAGA;;KAEI;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,iBAAiB;SACjB,eAAe;KACnB;;KAEA;SACI,iBAAiB;SACjB,eAAe;KACnB;;KAEA;SACI,UAAU;SACV,gBAAgB;SAChB,oBAAoB;KACxB;;KAEA;SACI,kBAAkB;SAClB,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;;CAGJ;;CAEA;;KAEI;SACI,mBAAmB;SACnB,eAAe;KACnB;;KAEA;SACI,wBAAwB;SACxB,eAAe;KACnB;;KAEA;SACI,kBAAkB;SAClB,eAAe;KACnB;;KAEA;SACI,gBAAgB;KACpB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,iBAAiB;KACrB;;KAEA;SACI,iBAAiB;KACrB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;SACf,mBAAmB;KACvB;;KAEA;SACI,WAAW;SACX,YAAY;KAChB;;KAEA;SACI,WAAW;KACf;;KAEA;SACI,WAAW;SACX,YAAY;KAChB;;KAEA;SACI,uBAAuB;KAC3B;;KAEA;SACI,sBAAsB;SACtB,SAAS;KACb;;KAEA;SACI,WAAW;SACX,YAAY;SACZ,cAAc;SACd,MAAM;KACV;;KAEA;SACI,UAAU;SACV,YAAY;SACZ,gBAAgB;KACpB;;KAEA;SACI,SAAS;KACb;;KAEA;SACI,gBAAgB;KACpB;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,aAAa;KACjB;;KAEA;;SAEI,kBAAkB;SAClB,UAAU;SACV,SAAS;KACb;;KAEA;SACI,SAAS;KACb;;KAEA;SACI,YAAY;KAChB;CACJ;;CAEA;;KAEI;;SAEI,0BAA0B;KAC9B;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;CACJ;;CAEA;;;KAGI;SACI,iBAAiB;KACrB;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,gBAAgB;SAChB,SAAS;KACb;;KAEA;SACI,iBAAiB;KACrB;;KAEA;SACI,eAAe;SACf,mBAAmB;KACvB;;KAEA;SACI,aAAa;SACb,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,kBAAkB;SAClB,sBAAsB;SACtB,SAAS;KACb;;KAEA;SACI,gBAAgB;SAChB,iBAAiB;KACrB;;KAEA;SACI,kBAAkB;SAClB,eAAe;KACnB;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,eAAe;SACf,mBAAmB;KACvB;;KAEA;SACI,WAAW;SACX,gBAAgB;SAChB,oBAAoB;KACxB;;KAEA;SACI,sBAAsB;KAC1B;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;SACf,mBAAmB;KACvB;;;KAGA;SACI,eAAe;SACf,SAAS;KACb;;KAEA;SACI,eAAe;SACf,SAAS;SACT,UAAU;KACd;;KAEA;SACI,gBAAgB;KACpB;;KAEA;SACI,uBAAuB;SACvB,mBAAmB;KACvB;;KAEA;SACI,eAAe;SACf,wBAAwB;KAC5B;;KAEA;SACI,oBAAoB;KACxB;;KAEA;SACI,gBAAgB;KACpB;;KAEA;SACI,eAAe;KACnB;;CAEJ;;;CAGA;;KAEI;SACI,iBAAiB;SACjB,eAAe;KACnB;;KAEA;SACI,kBAAkB;SAClB,eAAe;KACnB;;;CAGJ","sourcesContent":[" /* ========================================= */\n /*              GLOBAL STYLES                */\n /* ========================================= */\n .api-document-wrapper {\n     font-family: 'Inter', sans-serif;\n     color: #1a1a1a;\n     background: #ffffff;\n     line-height: 1.5;\n }\n\n /* ========================================= */\n /*               HERO SECTION                */\n /* ========================================= */\n .api-hero-section {\n     background-size: cover;\n     background-position: center;\n     padding: 40px 0px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     min-height: 550px;\n }\n\n .api-hero-container {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     max-width: 1480px;\n     padding: 0px 20px;\n     width: 100%;\n     margin: 0 auto;\n }\n\n .api-hero-content {\n     max-width: 550px;\n }\n\n .api-badge {\n     color: #D1AA67;\n     font-weight: 500;\n     font-size: 14px;\n     background-color: #FDF6E9;\n     margin-bottom: 15px;\n     display: inline-block;\n     border-radius: 15px;\n     font-weight: 600;\n     padding: 4px 10px;\n }\n\n .api-hero-content h1 {\n     font-size: 72px;\n     font-weight: 700;\n     margin-bottom: 20px;\n     color: #1a1a1a;\n     line-height: 1.1;\n }\n\n .api-hero-content h1 span {\n     color: #D1AA67;\n }\n\n .api-hero-content p {\n     font-size: 18px;\n     color: #4B5563;\n     line-height: 1.6;\n     margin-bottom: 30px;\n     max-width: 90%;\n }\n\n .api-btn-group {\n     display: flex;\n     gap: 15px;\n     margin-bottom: 45px;\n }\n\n .api-btn-group a {\n     padding: 15px 30px;\n     border-radius: 30px;\n     text-align: center;\n     font-weight: 700;\n     font-size: 14px;\n     transition: 0.3s;\n     text-decoration: none;\n }\n\n\n .btn-black {\n     background-color: #1a1a1a;\n     color: #fff;\n }\n\n .btn-black:hover {\n     background-color: #333;\n     color: #fff;\n }\n\n .btn-grey {\n     background-color: #ECECEC;\n     color: #1a1a1a;\n     text-decoration: none;\n }\n\n .btn-grey:hover {\n     background-color: #e4e4e4;\n }\n\n .api-features-list {\n     display: flex;\n     gap: 25px;\n     font-size: 12px;\n     color: #374151;\n     font-weight: 700;\n }\n\n .api-features-list span {\n     display: flex;\n     align-items: center;\n     gap: 6px;\n     text-decoration: underline;\n }\n\n .api-features-list svg {\n     color: #d2a154;\n }\n\n .api-hero-image img {\n     max-width: 590px;\n     width: 100%;\n }\n\n /* ========================================= */\n /*   ALL-IN-ONE TRADING DATA & ACCOUNT SRV   */\n /* ========================================= */\n .api-services-section {\n     padding: 80px 0px;\n     text-align: center;\n     background: #ffffff;\n }\n\n .api-services-container {\n     max-width: 1480px;\n     padding: 0px 20px;\n     margin: 0 auto;\n }\n\n .api-section-title {\n     font-size: 40px;\n     letter-spacing: 0.5px;\n     font-weight: 700;\n     margin-bottom: 12px;\n     color: #1a1a1a;\n }\n\n .api-section-subtitle {\n     font-size: 20px;\n     color: #6B7280;\n     margin-bottom: 50px;\n }\n\n /* DIAGRAM */\n .api-diagram {\n     position: relative;\n     max-width: 100%;\n     margin: 0 auto 30px auto;\n     padding-top: 40px;\n\n }\n\n .diagram-top-line {\n     position: absolute;\n     max-width: 85%;\n     margin: 0 auto;\n     top: 0;\n     left: 50px;\n     right: 50px;\n     border-top: 2px dashed #b3b3b3;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     z-index: 1;\n }\n\n .diagram-top-line .diagram-arrow-left {\n     position: absolute;\n     left: -10px;\n     top: -13px;\n     color: #b3b3b3;\n     font-size: 16px;\n }\n\n .diagram-top-line .diagram-arrow-right {\n     position: absolute;\n     right: -10px;\n     top: -13px;\n     color: #b3b3b3;\n     font-size: 16px;\n }\n\n .diagram-pill {\n     background: #ffffff;\n     border: 1px solid #eaeaea;\n     border-radius: 40px;\n     padding: 8px 18px;\n     font-size: 16px;\n     font-weight: 600;\n     color: #1a1a1a;\n     position: relative;\n     top: -21px;\n     z-index: 5;\n }\n\n .diagram-main-row {\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n     position: relative;\n }\n\n .diagram-item {\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     z-index: 10;\n     width: 120px;\n }\n\n .diagram-icon {\n     background: #f8efe1;\n     border-radius: 50%;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     margin-bottom: 15px;\n }\n\n .diagram-icon.large {\n     width: 100px;\n     height: 100px;\n }\n\n .diagram-icon.large img {\n     width: 50px;\n }\n\n .diagram-icon.small {\n     width: 80px;\n     height: 80px;\n     opacity: 1;\n }\n\n .diagram-icon.small img {\n     width: 35px;\n }\n\n .diagram-title {\n     font-weight: 600;\n     font-size: 24px;\n     color: #1a1a1a;\n }\n\n .diagram-line-container {\n     flex: 1;\n     display: flex;\n     align-items: center;\n     position: relative;\n     margin: 0 10px;\n     top: -15px;\n     /* align with the middle of circles (considering text is below) */\n }\n\n .diagram-line-dashed.gold {\n     width: 100%;\n     border-top: 2px dashed #d2af75;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     position: relative;\n }\n\n .diagram-line-dashed.gold .diagram-arrow-left {\n     position: absolute;\n     left: -8px;\n     top: -16px;\n     color: #d2af75;\n     font-size: 20px;\n }\n\n .diagram-line-dashed.gold .diagram-arrow-right {\n     position: absolute;\n     right: -8px;\n     top: -16px;\n     color: #d2af75;\n     font-size: 20px;\n }\n\n /* ========================================= */\n /*               SECTION DIVIDER             */\n /* ========================================= */\n\n\n .api-divider {\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     margin: 80px 0 0px 0;\n }\n\n .market_data_section .api-cards-grid {\n     margin-top: 45px;\n }\n\n .api-divider span {\n     font-size: 40px;\n     font-weight: 600;\n     letter-spacing: 0.5px;\n     margin: 0 20px;\n     color: #1a1a1a;\n }\n\n .market_data_section p {\n     font-size: 19px;\n     color: #6B7280;\n }\n\n .api-divider::before,\n .api-divider::after {\n     content: '';\n     height: 4px;\n     width: 40px;\n     background: #d2a154;\n }\n\n /* ========================================= */\n /*               CARDS LAYOUT                */\n /* ========================================= */\n .api-cards-grid {\n     display: grid;\n     grid-template-columns: 1fr 1fr;\n     gap: 24px;\n     max-width: 100%;\n     margin: 0 auto;\n     text-align: left;\n }\n\n .api-card {\n     background: #ffffff;\n     border-radius: 12px;\n     padding: 36px;\n     box-shadow: 0 0px 15px rgb(0 0 0 / 22%);\n     border: 1px solid #34353920;\n     border-left: 2.8px solid #343539;\n     display: flex;\n     flex-direction: column;\n     justify-content: flex-start;\n     transition: transform 0.2s, box-shadow 0.2s;\n }\n\n .api-card:hover {\n     transform: translateY(-2px);\n     box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);\n }\n\n .api-card h3 {\n     font-size: 28px;\n     font-weight: 700;\n     margin-bottom: 26px;\n     color: #1A1A1A;\n }\n\n .api-card p {\n     font-size: 17px;\n     color: #666;\n     margin-bottom: 24px;\n     line-height: 1.6;\n }\n\n .market_data_section .api-card h3 {\n     font-size: 24px;\n     margin-bottom: 6px;\n }\n\n .api-tags {\n     width: 70%;\n     display: grid;\n     grid-template-columns: repeat(2, 1fr);\n     gap: 15px;\n     column-gap: 32px;\n     margin-bottom: auto;\n     padding-bottom: 30px;\n }\n\n .api-tag {\n     background: #EBEBEB;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     padding: 11px 22px;\n     text-align: center;\n     border-radius: 40px;\n     font-size: 16px;\n     color: #333;\n     font-weight: 600;\n     border: 1px solid #F3F4F6;\n }\n\n .api-card-bottom {\n     margin-top: 10px;\n }\n\n .api-hot-module {\n     font-size: 15px;\n     color: #D1AA67;\n     font-weight: 600;\n     margin-bottom: 10px;\n }\n\n .api-card-action {\n     background: #EBEBEB;\n     padding: 16px 20px;\n     border-radius: 50px;\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n     text-decoration: none;\n     color: #1a1a1a;\n     font-size: 16px;\n     font-weight: 500;\n     transition: 0.2s;\n }\n\n .api-card-action:hover {\n     background: #d1aa67;\n     color: #ffff;\n }\n\n .api-card-action:hover svg {\n     color: #ffff;\n }\n\n .api-github-btn {\n     background: #d2a154;\n     color: #fff;\n     display: inline-flex;\n     align-items: center;\n     gap: 8px;\n     padding: 10px 20px;\n     border-radius: 25px;\n     text-decoration: none;\n     font-weight: 600;\n     font-size: 14px;\n     transition: 0.3s;\n }\n\n .api-github-btn:hover {\n     background: #c29144;\n     color: #fff;\n }\n\n /* ========================================= */\n /*               BENEFITS SECTION            */\n /* ========================================= */\n .api-benefits-section {\n     background-size: cover;\n     background-position: center;\n     padding: 80px 0px;\n     text-align: center;\n }\n\n .api-benefits-container {\n     max-width: 1480px;\n     padding: 0px 20px;\n     margin: 0 auto;\n }\n\n .api-benefits-grid {\n     display: grid;\n     grid-template-columns: 1fr 1fr;\n     gap: 32px;\n     margin-top: 40px;\n }\n\n .api-benefit-card {\n     background: #ffffff;\n     padding: 36px;\n     border-radius: 12px;\n     text-align: left;\n     border: 1px solid #EFEFEF;\n     box-shadow: 0 4px 20px rgb(0 0 0 / 9%);\n }\n\n .api-benefit-card h4 {\n     font-size: 24px;\n     font-weight: 700;\n     margin-bottom: 5px;\n     color: #1a1a1a;\n }\n\n .api-benefit-card p {\n     font-size: 17px;\n     color: #6B7280;\n     line-height: 1.6;\n }\n\n /* ========================================= */\n /*                  FAQ SECTION              */\n /* ========================================= */\n .api-faq-section {\n     padding: 60px 0px;\n     background: #ffffff;\n }\n\n .api-faq-container {\n     max-width: 1480px;\n     padding: 0px 20px;\n     margin: 0 auto;\n }\n\n .api-faq-container h2 {\n     font-size: 40px;\n     font-weight: 700;\n     margin-bottom: 30px;\n     text-align: left;\n     color: #1a1a1a;\n }\n\n .api-faq-item {\n     background: #F5F5F5;\n     border-radius: 10px;\n     padding: 20px 24px;\n     margin-bottom: 12px;\n     display: flex;\n     justify-content: space-between;\n     border: 1px solid #F3F4F6;\n     align-items: center;\n     cursor: pointer;\n     font-weight: 600;\n     font-size: 16px;\n     transition: background 0.3s;\n     color: #1a1a1a;\n }\n\n .api-faq-item:hover {\n     background: #f0f0f0;\n }\n\n .api-faq-answer {\n     padding: 0 24px 24px 24px;\n     font-size: 15px;\n     color: #666;\n     line-height: 1.6;\n     background: #f7f7f7;\n     border-radius: 0 0 8px 8px;\n     margin-top: -12px;\n     margin-bottom: 12px;\n }\n\n .api-faq-icon {\n     color: #999;\n     transition: transform 0.3s;\n }\n\n .api-faq-icon.open {\n     transform: rotate(180deg);\n }\n\n /* ========================================= */\n /*               RESPONSIVE                  */\n /* ========================================= */\n\n\n @media (max-width:1500px) {\n\n     .api-hero-container {\n         max-width: 95%;\n     }\n\n     .api-services-container {\n         max-width: 95%;\n     }\n\n     .api-benefits-container {\n         max-width: 95%;\n     }\n\n     .api-faq-container {\n         max-width: 95%;\n     }\n\n     .api-hero-content h1 {\n         font-size: 54px;\n     }\n\n\n }\n\n\n @media (max-width:1200px) {\n\n     .api-hero-content h1 {\n         font-size: 48px;\n     }\n\n     .api-hero-content p {\n         font-size: 16px;\n     }\n\n     .api-section-title {\n         font-size: 32px;\n     }\n\n     .api-card h3 {\n         font-size: 24px;\n     }\n\n     .diagram-title {\n         font-size: 20px;\n     }\n\n     .diagram-pill {\n         padding: 5px 14px;\n         font-size: 13px;\n     }\n\n     .api-tag {\n         padding: 9px 18px;\n         font-size: 13px;\n     }\n\n     .api-tags {\n         width: 90%;\n         column-gap: 18px;\n         padding-bottom: 18px;\n     }\n\n     .api-card-action {\n         padding: 13px 18px;\n         font-size: 14px;\n     }\n\n     .api-divider span {\n         font-size: 32px;\n     }\n\n     .market_data_section p {\n         font-size: 16px;\n     }\n\n     .market_data_section .api-card h3 {\n         font-size: 20px;\n     }\n\n     .api-benefit-card h4 {\n         font-size: 20px;\n     }\n\n     .api-benefit-card p {\n         font-size: 15px;\n     }\n\n     .api-faq-container h2 {\n         font-size: 32px;\n     }\n\n\n }\n\n @media (max-width: 992px) {\n\n     .api-hero-content {\n         margin-bottom: 10px;\n         max-width: 100%;\n     }\n\n     .api-hero-content p {\n         margin: 0 auto 24px auto;\n         max-width: 100%;\n     }\n\n     .api-btn-group a {\n         padding: 11px 24px;\n         font-size: 13px;\n     }\n\n     .api-hero-image img {\n         max-width: 470px;\n     }\n\n     .api-hero-content h1 {\n         font-size: 36px;\n     }\n\n     .api-hero-section {\n         min-height: 480px;\n     }\n\n     .api-services-section {\n         padding: 40px 0px;\n     }\n\n     .api-section-title {\n         font-size: 26px;\n     }\n\n     .api-section-subtitle {\n         font-size: 16px;\n         margin-bottom: 40px;\n     }\n\n     .diagram-icon.large {\n         width: 50px;\n         height: 50px;\n     }\n\n     .diagram-icon.large img {\n         width: 24px;\n     }\n\n     .diagram-icon.small {\n         width: 50px;\n         height: 50px;\n     }\n\n     .api-features-list {\n         justify-content: center;\n     }\n\n     .api-diagram {\n         flex-direction: column;\n         gap: 20px;\n     }\n\n     .diagram-line-container {\n         width: 100%;\n         height: 60px;\n         margin: 15px 0;\n         top: 0;\n     }\n\n     .diagram-line-dashed {\n         width: 1px;\n         height: 100%;\n         border-top: none;\n     }\n\n     .diagram-arrow-left {\n         top: -2px;\n     }\n\n     .diagram-line-dashed.gold {\n         border-top: none;\n     }\n\n     .diagram-main-row .diagram-arrow-right {\n         display: none;\n     }\n\n     .diagram-title {\n         font-size: 16px;\n     }\n\n     .api-faq-container h2 {\n         font-size: 26px;\n     }\n\n     .diagram-line-dashed.gold .diagram-arrow-left {\n         display: none;\n     }\n\n     .diagram-label-top,\n     .diagram-label-bottom {\n         position: absolute;\n         left: 20px;\n         margin: 0;\n     }\n\n     .diagram-label-top {\n         top: 10px;\n     }\n\n     .diagram-label-bottom {\n         bottom: 10px;\n     }\n }\n\n @media (max-width: 768px) {\n\n     .api-cards-grid,\n     .api-benefits-grid {\n         grid-template-columns: 1fr;\n     }\n\n     .api-hero-content h1 {\n         font-size: 42px;\n     }\n\n     .api-divider span {\n         font-size: 22px;\n     }\n }\n\n @media (max-width: 767px) {\n\n\n     .api-benefits-section {\n         padding: 30px 0px;\n     }\n\n     .api-benefit-card {\n         padding: 22px;\n     }\n\n     .api-benefits-grid {\n         margin-top: 20px;\n         gap: 24px;\n     }\n\n     .api-faq-section {\n         padding: 24px 0px;\n     }\n\n     .api-faq-container h2 {\n         font-size: 22px;\n         margin-bottom: 15px;\n     }\n\n     .api-faq-item {\n         padding: 15px;\n         font-size: 15px;\n     }\n\n     .api-hero-content h1 {\n         font-size: 32px;\n     }\n\n     .api-hero-container {\n         text-align: center;\n         flex-direction: column;\n         gap: 24px;\n     }\n\n     .api-hero-section {\n         min-height: 100%;\n         padding: 50px 0px;\n     }\n\n     .api-btn-group a {\n         padding: 10px 15px;\n         font-size: 12px;\n     }\n\n     .api-card {\n         padding: 24px;\n     }\n\n     .api-card h3 {\n         font-size: 20px;\n         margin-bottom: 20px;\n     }\n\n     .api-tags {\n         width: 100%;\n         column-gap: 12px;\n         padding-bottom: 15px;\n     }\n\n     .api-services-section {\n         padding: 10px 0px 40px;\n     }\n\n     .api-section-title {\n         font-size: 22px;\n     }\n\n     .api-section-subtitle {\n         font-size: 15px;\n         margin-bottom: 30px;\n     }\n\n\n     .diagram-main-row {\n         flex-wrap: wrap;\n         gap: 18px;\n     }\n\n     .diagram-top-line {\n         max-width: 100%;\n         left: 0px;\n         right: 0px;\n     }\n\n     .api-hero-image img {\n         max-width: 340px;\n     }\n\n     .api-btn-group {\n         justify-content: center;\n         margin-bottom: 28px;\n     }\n\n     .api-hero-content p {\n         font-size: 15px;\n         margin: 0 auto 18px auto;\n     }\n\n     .api-divider {\n         margin: 40px 0 0px 0;\n     }\n\n     .market_data_section .api-cards-grid {\n         margin-top: 24px;\n     }\n\n     .market_data_section p {\n         font-size: 15px;\n     }\n\n }\n\n\n @media (max-width:580px) {\n\n     .api-tag {\n         padding: 8px 15px;\n         font-size: 12px;\n     }\n\n     .api-card-action {\n         padding: 12px 18px;\n         font-size: 13px;\n     }\n\n\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
